module.exports = __webpack_public_path__ + "img/serviceplanner-offers-overlay-en.bd23a1e0.webp";